<script> 
  import SlideIt from "svelte-glidejs";
  
    let options = {
    type: 'slide',focusAt:'center',
    direction:'ltr',
    startAt: 0,
    perView: 1, gap:0,
    hoverpause: true,
    autoplay: 5000
  } 
    let listslide = [
      {
        "title": "#LagiTren",
        "subtitle": "Hijau Di Ruangan Kamu",
        "img": "https://images.unsplash.com/photo-1562587828-de93c5454a17?ixlib=rb-1.2.1&auto=format&fit=crop&w=1260&h=300&q=80",
        "url": "./belanja/c/rumah-tangga-taman-benih-bibit-tanaman/q/-"
      },
      {
        "title": "#DekatDapur",
        "subtitle": "Kebutuhan Dapur Kamu",
        "img": "https://images.unsplash.com/photo-1474440692490-2e83ae13ba29?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1260&h=300&q=80",
        "url": "./belanja/c/rumah-tangga/q/-"
      },
      {
        "title": "#MakananLokal",
        "subtitle": "Makanan Di Sekitar Kamu",
        "img": "https://images.unsplash.com/photo-1600004637343-27fc104f67b8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1260&h=300&q=80",
        "url": "./belanja/c/makanan-minuman/q/-"
      }
  ];
  </script>
  
  <div 
    class="relative w-full overflow-hidden bg-white bg-opacity-100 rounded-lg shadow-2xl lg:rounded-lg lg:bg-white lg:bg-opacity-75">
     
      
      <SlideIt {options} bullet=true control=true items={listslide}>
         
        <a slot="item" let:item href="{item.url}" class="block w-full leading-tight text-black bg-indigo-700 rounded-lg shadow-lg lg:p-10 " style="height:300px;background: url('{item.img}') center center / cover;"> 

          <div class="w-full pt-24 pl-0 text-center lg:pt-0 lg:pl-5 lg:text-left"><span class="text-2xl font-light lg:text-4xl"> <span class="px-2 bg-white bg-opacity-75 rounded">{item.subtitle}</span> </span><br/><h2 class="text-2xl font-bold lg:text-4xl"><span class="px-2 bg-white bg-opacity-75 rounded">{item.title}</span></h2></div> 
        </a>  
       </SlideIt>
       
  </div> 